import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class LdaGraph extends AbstractScatterVisualization {
}
